import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_ORDER_SYNC_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_ORDER_SYNC_API_ID';

const apiCall = createApiCall(
  FETCH_INVESTCORE_ORDER_SYNC_API_ID,
  ({ id, payload }) => ({
    endpoint: `/api/admin/orders/${id}/vcam/sync-order-status`,
    method: 'POST',
    body: payload,
    notify: true,
    isStay: true,
  })
);

export default apiCall;
